<template>
  <div class="app">
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>

export default {
  name: "App",
  components: {
  },
  data() {
    return {};
  },
  mounted() {
  },
};
</script>

<style>
/* 通用 */
* {
  margin: 0;
  padding: 0;
}

.app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f1f1f17d;
}

.content {
  flex: 1;
}

/* 强制隐藏目标元素 */
body>p[align="center"] {
  display: none !important;
  visibility: hidden !important;
  height: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  left: -9999px;
}
</style>
